import IcecatForm from "../generatedForms/Icecat";
import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useSearchParams } from "react-router-dom";
import FormSkeleton from "../components/Skeleton/FormSkeleton";
import { getIcecatReference, getIcecatSingleProduct } from "../generatedRequest/icecatdata";

type TAccessoryModalProps = {
  isEdit: boolean;
};

const IcecatFormModal = ({ isEdit }: TAccessoryModalProps) => {
  const [loading, setLoading] = useState(false);
  const [queryParameters] = useSearchParams();
  const [icecatProductData, setIcecatProductData] = useState<any[]>([]);
  const [ProductData, setProductData] = useState<any[]>([]);
  const [referenceError, setReferenceError] = useState<string>("");
  const productID = queryParameters.get("q") || "";
 const [initload, setInitload] = useState(true);
  // console.log(productID, "productID")
  
  useEffect(() => {
    const fetchIcecatProductData = async () => {
      setLoading(true);
      try {
        const response = await getIcecatSingleProduct(productID);
        if (response.data.status) {
          // Ensure the data is always an array
          setIcecatProductData(Array.isArray(response.data.data) ? response.data.data : [response.data.data]);
        } else {
          toast.error("Something went wrong");
        }
      } catch (error) {
        toast.error("Network Error");
      } finally {
        setLoading(false);
      }
    };

    if (productID) {
      fetchIcecatProductData();
    }
  }, [ isEdit, productID]);

 
// console.log(icecatProductData , "icecatProductData")



 useEffect(() => {
    const fetchIcecatRefrenceProductData = async () => {
      
      try {
        let refrenceId = icecatProductData[0]?.icecatReferenceNumber;
        const response = await getIcecatReference(refrenceId);

        if (response.data.status) {
          // Ensure the data is always an array
          setProductData(Array.isArray(response.data.data) ? response.data.data : [response.data.data]);
          setReferenceError(""); // Clear any previous error
        } else {
          setLoading(false);
          const errorMessage = "Product with this reference number does not exist or has been deleted";
          setReferenceError(errorMessage); // Set error message in state
       
        }
      } catch (error) {
        const errorMessage = "Network Error";
        setReferenceError(errorMessage); // Set error message in state
        toast.error(errorMessage);
      }
    };

    if (icecatProductData.length > 0) {
      fetchIcecatRefrenceProductData();
    }
  }, [icecatProductData]);

  if (loading) {
    return <FormSkeleton numberOfInput={8} />;
  }
  return (
    <>
      <IcecatForm 
        isloading={loading}
        isEdit={isEdit}
        icecatProductData={icecatProductData}
        ProductData={ProductData}
        errors={{}} // Provide appropriate error object or state
      
        values={{}} // Provide appropriate values object or state
        referenceError={referenceError} // Pass the error message as prop
      />
    </>
  );
};

export default IcecatFormModal;